const siteHeader=document.getElementById("shopify-section-header"),headerUspBar=document.getElementById("shopify-section-usp-bar"),productSection=document.querySelector(".section-product"),productBreadcrumbs=document.querySelector(".breadcrumbs"),productWrapper=productSection.querySelector(".wrap"),productDetails=productSection.querySelector(".section-product__details");let headerHeight=0,headerUspBarHeight=0,breadcrumbsHeight=0,productDetailsHeight=0,wrapperPadding=0;window.heightFromTop=e=>{var t;1024<=e?(e=window.innerHeight,productDetails&&(productDetailsHeight=productDetails.offsetHeight),productWrapper&&(wrapperPadding=window.getComputedStyle(productWrapper,null).getPropertyValue("padding-top")),t=Number(wrapperPadding.replace("px","")),(t=e-(e=headerHeight+headerUspBarHeight+t))>productDetailsHeight?productDetails.style.top=e+"px":(e=e-(productDetailsHeight-t)-20,productDetails.style.top=e+"px"),productDetails.style.position="sticky"):(productDetails.style.position="relative",productDetails.style.top="auto")};const buttonsWrapper=document.querySelector(".section-product__details__actions"),buttons=document.querySelector(".action-wrapper"),reviewSnippetElement=(window.addEventListener("scroll",()=>{window.innerWidth<=1024&&(buttonsWrapper.getBoundingClientRect().top<0?buttons.classList.add("sticky"):buttons.classList.remove("sticky"))}),document.querySelector('.section-product__details__price div[data-pr-component="CategorySnippet"]'));reviewSnippetElement&&reviewSnippetElement.addEventListener("click",()=>{var e=document.querySelector(".section-product-reviews");e&&e.scrollIntoView({behaviour:"smooth",block:"start"})});
/* === Variant Size Sorting (numeric + apparel, observer-safe) === */
(function () {
  // Order for apparel sizes if values aren't numeric
  const APPAREL_ORDER = [
    "XXXS","XXS","XS","S","M","L","XL","XXL","2XL","3XL","4XL","5XL",
    "OS","ONE SIZE","ONE SIZE FITS MOST","OSFM"
  ];

  const productRoot = (typeof productSection !== "undefined" && productSection) || document;
  let isSorting = false;
  let mo, debounceId;

  function parseNum(v) {
    const m = String(v || "").trim().match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : NaN;
  }

  function norm(s) { return String(s || "").trim().toUpperCase(); }

  // Rank for apparel sizes; supports e.g. "S/M" by taking the lowest rank present
  function apparelRank(v) {
    const tokens = norm(v).split(/[\/\-\s]+/).filter(Boolean);
    let best = 999;
    for (const t of tokens) {
      const idx = APPAREL_ORDER.indexOf(t);
      if (idx !== -1 && idx < best) best = idx;
    }
    return best;
  }

  function looksNumericSet(labels) {
    if (!labels.length) return false;
    let numeric = 0;
    for (const lab of labels) {
      const input = lab.querySelector('input[type="radio"]');
      const val = input?.value || lab.textContent;
      if (Number.isFinite(parseNum(val))) numeric++;
    }
    // Consider it “numeric sizes” if a majority are numeric OR none are numeric (we’ll still sort by apparel later)
    return numeric >= Math.ceil(labels.length * 0.6) || numeric === 0;
  }

  function checksum(arr) { return arr.join("|"); }

  function sortOneContainer(container) {
    const labels = Array.from(container.querySelectorAll(':scope > label'));
    if (!labels.length) return;

    if (!looksNumericSet(labels)) return;

    const currentValues = labels.map(l => {
      const input = l.querySelector('input[type="radio"]');
      return (input?.value || l.textContent || "").trim();
    });
    const currentSig = checksum(currentValues);

    const items = labels.map(lab => {
      const input = lab.querySelector('input[type="radio"]');
      const raw = (input?.value || lab.textContent || "").trim();
      const num = parseNum(raw);
      const ar = apparelRank(raw);
      return { lab, raw, num, ar };
    });

    items.sort((a, b) => {
      const an = a.num, bn = b.num;
      const aNum = Number.isFinite(an), bNum = Number.isFinite(bn);
      if (aNum && bNum) return an - bn;                 // numeric vs numeric
      if (aNum && !bNum) return -1;                     // numeric before apparel/other
      if (!aNum && bNum) return 1;
      // neither numeric → try apparel rank
      if (a.ar !== b.ar) return a.ar - b.ar;
      // fallback natural
      return a.raw.localeCompare(b.raw, undefined, { numeric: true, sensitivity: "base" });
    });

    const sortedValues = items.map(i => i.raw);
    const sortedSig = checksum(sortedValues);
    if (currentSig === sortedSig) {
      container.dataset.sizeSorted = "1";
      container.dataset.sizeSortedSig = sortedSig;
      return;
    }

    const checked = container.querySelector('input[type="radio"]:checked');
    const checkedId = checked?.id;

    if (mo) mo.disconnect();
    isSorting = true;

    const frag = document.createDocumentFragment();
    for (const it of items) frag.appendChild(it.lab);
    container.appendChild(frag);

    if (checkedId) {
      const again = container.querySelector(`#${CSS.escape(checkedId)}`);
      if (again && !again.checked) {
        again.checked = true;
        again.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    container.dataset.sizeSorted = "1";
    container.dataset.sizeSortedSig = sortedSig;

    isSorting = false;
    if (mo) observe();
  }

  function run(scope) {
    if (isSorting) return;
    const root = scope || productRoot;
    root.querySelectorAll('.variant-options').forEach(container => {
      try { sortOneContainer(container); } catch (_) {}
    });
  }

  function debouncedRun(scope) {
    clearTimeout(debounceId);
    debounceId = setTimeout(() => run(scope), 50);
  }

  function observe() {
    if (!productRoot) return;
    mo = new MutationObserver(muts => {
      if (isSorting) return;
      for (const m of muts) {
        if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
          const touchesVariant =
            (m.target && (m.target.matches?.('.variant-options') || m.target.closest?.('.variant-options'))) ||
            Array.from(m.addedNodes || []).some(n => n.nodeType === 1 && (n.matches?.('.variant-options') || n.querySelector?.('.variant-options')));
          if (touchesVariant) { debouncedRun(productRoot); break; }
        }
      }
    });
    mo.observe(productRoot, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => run(productRoot));
  } else {
    run(productRoot);
  }

  document.addEventListener("shopify:section:load", e => debouncedRun(e.target));
  document.addEventListener("shopify:section:reorder", e => debouncedRun(e.target));

  try { observe(); } catch (_) {}
})();
